import React, { useEffect, useState } from 'react';
import {
  Box,
  Typography,
  Collapse,
  RadioGroup,
  FormControlLabel,
  Radio,
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField,
  Button,
  Checkbox
} from '@mui/material';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import { api } from 'src/Api';
import ProjectManagerDropdown from '../ProjectManagerDropdown';

const AudienceForm = ({
  secondFormOpen,
  formData,
  errors,
  handleSecondFormOpen,
  handleChangeRadio,
  handleChangevalue,
  handleCheckboxChangePostOption,
  disabled
}) => {
  const [groupList, setGroupList] = useState([]);

  useEffect(() => {
    getGroupList();
  }, []);

  function getGroupList() {
    const myHeaders = new Headers();

    const token = localStorage.getItem('token');
    myHeaders.append('Authorization', `Bearer ${token}`);

    const requestOptions = {
      method: 'GET',
      headers: myHeaders,
      redirect: 'follow'
    };

    fetch(api.get_group_list, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        setGroupList(result.data);
      })
      .catch((error) => console.log('error', error));
  }
  return (
    <Box
      sx={{ boxShadow: '0px 4px 5px rgba(0, 0, 0, 0.1)', mt: 2 }}
      style={{
        borderRadius: 6,
        borderBottomLeftRadius: secondFormOpen ? 6 : 6,
        borderBottomRightRadius: secondFormOpen ? 6 : 6
      }}
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'flex-start',
          alignItems: 'center',
          cursor: 'pointer',
          backgroundColor: '#010f58',
          height: 40,
          padding: '0px 15px 0px 15px'
        }}
        style={{
          borderRadius: 6,
          borderBottomLeftRadius: secondFormOpen ? 0 : 6,
          borderBottomRightRadius: secondFormOpen ? 0 : 6
        }}
        onClick={handleSecondFormOpen}
      >
        <Typography
          variant="overline"
          sx={{ flex: 1, fontSize: 13, textTransform: 'capitalize', color: '#ffffff' }}
        >
          Select your Audience
        </Typography>
        {secondFormOpen ? (
          <ExpandLess sx={{ color: '#ffffff' }} />
        ) : (
          <ExpandMore sx={{ color: '#ffffff' }} />
        )}
      </Box>

      <Box>
        <Collapse in={secondFormOpen}>
          <Box
            sx={{ flexWrap: 'nowrap', padding: '0px 15px 0px 15px' }}
            style={{
              borderBottomLeftRadius: secondFormOpen ? 6 : 0,
              borderBottomRightRadius: secondFormOpen ? 6 : 0
            }}
          >
            <Typography
              sx={{
                fontSize: 13,
                lineHeight: 1.3,
                color: '#a9a9a9',
                marginTop: 2
              }}
            >
              Customize your audience for this shipment within the Post All and your Private Network
            </Typography>

            <Typography
              sx={{
                fontSize: 14,
                lineHeight: 1.3,
                color: '#010f58',
                marginTop: 2
              }}
            >
              Select at least one posting option:
            </Typography>

            <Box style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center' }}>
              <Box
                style={{
                  display: 'flex',
                  justifyContent: 'flex-start',
                  alignItems: 'center',
                  flex: 1
                }}
              >
                <Checkbox
                  disabled={disabled}
                  onChange={() => handleCheckboxChangePostOption('Private')} // Call with 'private' when checked
                  color="primary"
                  size="small"
                  checked={formData?.postOption === 'Private'} // Check if this checkbox is selected
                />
                <Typography
                  sx={{
                    fontSize: 12,
                    color: '#010f58'
                  }}
                >
                  Post to Private Network
                </Typography>
              </Box>
              <Box
                style={{
                  display: 'flex',
                  justifyContent: 'flex-start',
                  alignItems: 'center',
                  flex: 1
                }}
              >
                <Checkbox
                  disabled={disabled}
                  onChange={() => handleCheckboxChangePostOption('All')} // Call with 'all' when checked
                  color="primary"
                  size="small"
                  checked={formData?.postOption === 'All'} // Check if this checkbox is selected
                />
                <Typography
                  sx={{
                    fontSize: 12,
                    color: '#010f58'
                  }}
                >
                  Post to All
                </Typography>
              </Box>
            </Box>
            {errors.postOption && (
              <Typography variant="caption" color="error" sx={{ marginLeft: 2 }}>
                {errors.postOption}
              </Typography>
            )}

            {formData?.postOption == 'Private' && (
              <RadioGroup
                sx={{ marginBottom: 1, flexDirection: 'column', marginLeft: 5 }}
                row
                value={formData?.private_network}
                onChange={handleChangeRadio}
                name="private_network"
              >
                <FormControlLabel
                  disabled={disabled}
                  value="Private"
                  control={<Radio size="small" />}
                  label={
                    <Typography style={{ fontSize: '12px', color: '#010f58' }}>
                      Entire Private Network
                    </Typography>
                  }
                />
                <FormControlLabel
                  disabled={disabled}
                  value="Group"
                  control={<Radio size="small" />}
                  label={
                    <Typography style={{ fontSize: '12px', color: '#010f58' }}>
                      Specfic Groups
                    </Typography>
                  }
                />
              </RadioGroup>
            )}
            {errors.private_network && formData?.postOption == 'Private' && (
              <Typography variant="caption" color="error" sx={{ marginLeft: 2 }}>
                {errors.private_network}
              </Typography>
            )}

            {formData?.private_network == 'Group' && formData?.postOption == 'Private' && (
              <ProjectManagerDropdown
                label="Group"
                name="group_id"
                value={formData?.group_id}
                onChange={handleChangevalue}
                showNameTag={false}
                options={groupList.map((val) => ({
                  value: val?.id,
                  name: val?.name
                }))}
                error={Boolean(errors.group_id)}
                // helperText={errors.group_id}
                placeholder=""
                labelFontMedium
              />
            )}

            {formData?.private_network == 'Group' &&
              formData?.postOption == 'Private' &&
              Boolean(errors.group_id) && (
                <Typography variant="caption" color="error" sx={{ marginLeft: 2 }}>
                  {errors.group_id}
                </Typography>
              )}
          </Box>
        </Collapse>
      </Box>
    </Box>
  );
};

export default AudienceForm;
